import { Injectable, inject } from '@angular/core';
import { WindowRef } from '../window/window-ref';
import { StorageKey } from '@boels/models';

export interface StorageService {
  setItem<T>(key: StorageKey, state: T): void;
  getItem<T>(key: StorageKey): T;
  removeItem(key: StorageKey): void;
}

@Injectable({ providedIn: 'root' })
export class LocalStorageService implements StorageService {
  private windowRef = inject(WindowRef);

  fixedVersion = '5.0.0';

  setItem<T>(key: StorageKey | string, state: T) {
    this.windowRef.localStorage?.setItem(
      `${this.fixedVersion}-${key}`,
      JSON.stringify(state),
    );
  }

  getItem<T>(key: StorageKey | string): T {
    const item = this.windowRef.localStorage?.getItem(
      `${this.fixedVersion}-${key}`,
    );
    return item && item !== 'undefined' && JSON.parse(item);
  }

  removeItem(key: StorageKey): void {
    this.windowRef.localStorage?.removeItem(`${this.fixedVersion}-${key}`);
  }
}
